export default __webpack_public_path__ + "static/media/Mystic's Belt of the Soaring God.b816f9ee.jpg";